import type { Task } from '@shared/types';
import { Archive, CircleCheck, CopyPlus, ExternalLink, Link2, Trash2 } from '@/components/ui/icons';
import { getDb } from '@/lib/store';
import { subtaskCount } from '@/lib/query';
import { archiveTask, completeTask, deleteTask, duplicateTask } from '@/lib/actions';
import { useOpenTask } from '@/lib/nav';
import { Menu, MenuItem, MenuSeparator } from '@/components/ui/Menu';
import { toast } from '@/components/ui/overlays';
import { Icon } from '@/components/ui/Icon';
import { MoveTaskMenu } from '@/views/MoveTaskMenu';

/** Right-click / "…" menu for a task, shared by every view. */
export function TaskContextMenu({ task, close }: { task: Task; close: () => void }) {
  const openTask = useOpenTask();
  return (
    <Menu style={{ width: 230 }}>
      <MenuItem icon={<ExternalLink size={15} />} label="Open" onClick={() => (close(), openTask(task.id))} />
      <MenuItem
        icon={<Link2 size={15} />}
        label="Copy link"
        onClick={() => {
          const url = new URL(window.location.href);
          url.searchParams.set('t', task.id);
          void navigator.clipboard.writeText(url.toString());
          toast('Task link copied');
          close();
        }}
      />
      <MenuItem icon={<CircleCheck size={15} />} label="Mark complete" onClick={() => (completeTask(task.id), close())} />
      <MenuSeparator />
      <MenuItem
        icon={<CopyPlus size={15} />}
        label="Duplicate"
        onClick={() => {
          duplicateTask(task.id);
          toast('Task duplicated');
          close();
        }}
      />
      <MenuItem icon={<Icon name="ArrowRight" size={15} />} label="Move to" submenu={(c2) => <MoveTaskMenu taskIds={[task.id]} onDone={() => (c2(), close())} />} />
      <MenuItem
        icon={<Archive size={15} />}
        label="Archive"
        onClick={() => {
          archiveTask(task.id, true);
          toast('Task archived', { label: 'Undo', onClick: () => archiveTask(task.id, false) });
          close();
        }}
      />
      <MenuSeparator />
      <MenuItem
        icon={<Trash2 size={15} />}
        label="Delete"
        danger
        onClick={() => {
          close();
          if (confirm(`Delete "${task.name}"${subtaskCount(getDb(), task.id) ? ' and its subtasks' : ''}?`)) deleteTask(task.id);
        }}
      />
    </Menu>
  );
}

